import { Languages } from "./languages.model";

export class JobsLanguages {
  private id: number;
  private languages: Languages;
  private level: string;
  private rating: number;

  constructor(JobsLanguages: any) {
    this.id = JobsLanguages.id;
    this.languages = JobsLanguages.languages;
    this.level = JobsLanguages.level;
    this.rating = JobsLanguages.rating;
  }

  getLanguage(): Languages {
    return this.languages;
  }

  getLevel(): string {
    return this.level;
  }

  getRating(): number {
    return this.rating;
  }

}